<template>
  <div>
    <v-btn
    color="red darken-2"
    class="white--text text-darken-4"
    @click="btnMap_Click"
    target="_blank"
    v-if="isMobile">
   <v-icon>mdi-map</v-icon> Apri in Maps
    </v-btn>
    <iframe
    v-if="!isMobile"
      width="100%"
      height="200"
      id="gmap_canvas"
      v-bind:src="mapUrl"
      frameborder="0"
      scrolling="no"
      marginheight="0"
      marginwidth="0"
    >
    </iframe>
  </div>
</template>


 <style lang="">
</style> 
<script>
export default {
    props:["indirizzo", "citta"],
  data: () => ({isMobile:false}),
  created(){
    this.checkIfIsMobile();
  },
  methods:{
    btnMap_Click(){
      window.open(this.wMapUrl);
    },
     checkIfIsMobile() {
      this.isMobile= window.innerWidth < 600;
    },
  },
  computed: {
    mapUrl() {
      return (
        "https://maps.google.com/maps?q=" +
        this.mapQuery +
        "&t=&z=13&ie=UTF8&iwloc=&output=embed"
      );
    },
    wMapUrl() {
      return (
        "https://maps.google.com/maps?q=" +
        this.mapQuery  
      );
    },
    mapQuery() {
      return this.indirizzo + ", " + this.citta;
    },
  },
};
</script>

